import classNames from 'classnames';
import React from 'react';
import './input.scss';
export default function InputComponent(props) {
  const {
    type,
    isDisabled,
    inputStyle,
    placeholder,
    value,
    onChange,
    onBlur,
    info,
    mode,
    handleEnter = () => {},
    blockSpace,
  } = props;
  const infoClass = classNames('d-ib fs-8 fw-900 c-error');
  const onEnterKey = (e) => {
    if (blockSpace && e.keyCode === 32) {
      e.preventDefault();
    }
    if (e.keyCode === 13) {
      handleEnter(e);
    }
  };

  return (
    <div className="input-main">
      <input
        type={type}
        className={inputStyle}
        placeholder={placeholder}
        onChange={(e) => {
          onChange && onChange(e);
        }}
        inputMode={mode}
        value={value}
        onBlur={onBlur}
        onKeyDown={onEnterKey}
        disabled={isDisabled}
      />
      {info && (
        <div className="mb-5">
          <label className={infoClass}>{info}</label>
        </div>
      )}
    </div>
  );
}
